import { createFileRoute } from '@tanstack/react-router';
import { cachedApprovedOrganization, organizationEventQuery } from '@/features/organizer/api';
import { EditEventPage } from '@/features/organizer/pages/EventFormPage';

export const Route = createFileRoute('/_authed/org/$organizationId/events/$eventId/edit')({
  staticData: { help: 'event-form' },
  loader: ({ context: { queryClient }, params }) => {
    const organization = cachedApprovedOrganization(queryClient, params.organizationId);
    if (organization)
      void queryClient.prefetchQuery(organizationEventQuery(organization, params.eventId));
  },
  component: EditEventRoute,
});

function EditEventRoute() {
  const { eventId } = Route.useParams();
  return <EditEventPage eventId={eventId} />;
}
